import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as SuccessIcon } from "Assets/Icons/Settings/SuccessIcon.svg";

const ConfirmationDialog = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={Boolean(open)}
      onClose={() => handleClose()}
    >
      <DialogTitle>
        {" "}
        {Translation?.Confirmation}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <PrimaryIcon icon={SuccessIcon} height="70px" width="70px" />
        <br />
        <br />
        <Typography variant="subtitle" fontWeight={500}>
          {Translation?.YourWorkExperience}{" "}
          <Typography variant="subtitle" color="primary" fontWeight={500}>
            {" "}
            {Translation?.DefaultResume}{" "}
          </Typography>
        </Typography>
        <Typography mt={"10px"}>
          {Translation?.IntegratedResumeBuilder}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
